import { useEffect, useState } from "react";

export function useActiveSection(): string {
  const [activeSection, setActiveSection] = useState("inicio");

  useEffect(() => {
    function handleScroll() {
      const sections = document.querySelectorAll<HTMLElement>("section[id]");
      let current = "inicio";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;

        if (window.scrollY >= sectionTop - 150) {
          current = section.getAttribute("id") ?? current;
        }
      });

      setActiveSection(current);
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return activeSection;
}
